import { Button, message, Tag } from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { GenericList } from './common/GenericList';
import { $ } from '../lib/api';
import { fmtMonthDayTime } from '../lib/format';

export function PoolPage() {
  const qc = useQueryClient();
  const grab = useMutation({
    mutationFn: (id: number) => $.post(`/customers/${id}/grab`),
    onSuccess: () => { message.success('抢到了！'); qc.invalidateQueries(); },
  });
  return (
    <GenericList
      endpoint="/pool"
      title="公海池"
      columns={[
        { title: '昵称', dataIndex: 'nickname' },
        { title: '来源', dataIndex: 'source' },
        { title: '阶段', dataIndex: 'currentStage', render: (s: string) => <Tag>{s}</Tag> },
        { title: '进入公海原因', dataIndex: 'poolReason' },
        { title: '进入时间', dataIndex: 'poolEnteredAt', render: (t: string) => fmtMonthDayTime(t) },
        { title: '操作', render: (_: any, r: any) =>
          <Button type="primary" size="small" loading={grab.isPending} onClick={() => grab.mutate(r.id)}>抢单</Button> },
      ]}
    />
  );
}
